import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white to-do-list-box letter-spacing" }
const _hoisted_2 = { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "upload-box" }
const _hoisted_6 = { class: "upload-content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "upload-box mt-4" }
const _hoisted_10 = { class: "upload-content" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = {
  key: 1,
  class: "status"
}
const _hoisted_13 = {
  key: 0,
  class: "pending"
}
const _hoisted_14 = {
  key: 1,
  class: "success"
}
const _hoisted_15 = { class: "reason" }
const _hoisted_16 = {
  key: 2,
  class: "p-6 bg-slate-50 border-t"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "card mb-25 border-0 rounded-0 bg-white to-do-list-box letter-spacing" }
const _hoisted_19 = { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_20 = {
  key: 0,
  class: "upload-box large"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "success" }
const _hoisted_24 = {
  key: 1,
  class: "status"
}
const _hoisted_25 = {
  key: 0,
  class: "pending"
}
const _hoisted_26 = {
  key: 1,
  class: "success"
}
const _hoisted_27 = { class: "reason" }
const _hoisted_28 = {
  key: 0,
  class: "p-6 bg-slate-50 border-t"
}
const _hoisted_29 = ["disabled"]

import api from '@/utils/axios'
import { ref, reactive, onMounted } from 'vue'

/* ================= TYPES ================= */

interface UserVerification {
  ask_cin_verified: boolean
  ask_cntr_verified: boolean
  cin_verified: number
  contrat_verified: number
  raison_cin_verified?: string
  raison_cntr_verified?: string
}

/* ================= STATE ================= */


export default /*@__PURE__*/_defineComponent({
  __name: 'VerificationDocs',
  setup(__props) {

const user = reactive<UserVerification>({
  ask_cin_verified: false,
  ask_cntr_verified: false,
  cin_verified: 0,
  contrat_verified: 0
})

const cinRecto = ref<File | null>(null)
const cinVerso = ref<File | null>(null)
const contratFile = ref<File | null>(null)
const loading = ref(false)

/* ================= API ================= */

const loadStatus = async (): Promise<void> => {
  try {
    const { data } = await api.get<UserVerification>(
      '/api/auth/verification/status'
    )

    Object.assign(user, data)
  } catch (error) {
    console.error('Failed to load verification status', error)
  }
}

/* ================= ACTIONS ================= */

const sendCin = async (): Promise<void> => {
  if (!cinRecto.value || !cinVerso.value) {
    alert('Veuillez sélectionner les deux fichiers CIN')
    return
  }

  const formData = new FormData()
  formData.append('cin_recto', cinRecto.value)
  formData.append('cin_verso', cinVerso.value)

  try {
    loading.value = true

    await api.post('/api/auth/verification/cin', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    cinRecto.value = null
    cinVerso.value = null

    await loadStatus()
  } catch (error) {
    console.error('CIN upload failed', error)
    alert('Erreur lors de l’envoi du CIN')
  } finally {
    loading.value = false
  }
}

const sendContrat = async (): Promise<void> => {
  if (!contratFile.value) {
    alert('Veuillez sélectionner un fichier contrat')
    return
  }

  const formData = new FormData()
  formData.append('contrat', contratFile.value)

  try {
    loading.value = true

    await api.post('/api/auth/verification/contrat', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    contratFile.value = null

    await loadStatus()
  } catch (error) {
    console.error('Contrat upload failed', error)
    alert('Erreur lors de l’envoi du contrat')
  } finally {
    loading.value = false
  }
}

/* ================= HELPERS ================= */

const resetCin = (): void => {
  user.ask_cin_verified = false
  cinRecto.value = null
  cinVerso.value = null
}

const resetContrat = (): void => {
  user.ask_cntr_verified = false
  contratFile.value = null
}

const onCinRectoChange = (e: Event): void => {
  cinRecto.value = (e.target as HTMLInputElement).files?.[0] || null
}

const onCinVersoChange = (e: Event): void => {
  cinVerso.value = (e.target as HTMLInputElement).files?.[0] || null
}

const onContratChange = (e: Event): void => {
  contratFile.value = (e.target as HTMLInputElement).files?.[0] || null
}

const clearContrat = (): void => {
  contratFile.value = null
}

/* ================= LIFECYCLE ================= */

const iconClass = (file: File | null) =>
  file ? 'icon success-bg' : 'icon'

  const buttonClass = (disabled: boolean) =>
  disabled
    ? 'btn disabled'
    : 'btn active'
onMounted(loadStatus)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
          _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Pièce d'Identité (C.I.N)")
        ], -1)),
        (!user.ask_cin_verified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-slate-500 mb-4" }, " Téléchargez le recto et verso de votre carte nationale. ", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, [
                  _createElementVNode("input", {
                    type: "file",
                    hidden: "",
                    accept: "image/*,application/pdf",
                    onChange: onCinRectoChange
                  }, null, 32),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: _normalizeClass(iconClass(cinRecto.value))
                    }, "RECTO", 2),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(cinRecto.value?.name ?? "Charger le recto"), 1),
                      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "hint" }, "JPG, PNG, PDF", -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, [
                  _createElementVNode("input", {
                    type: "file",
                    hidden: "",
                    accept: "image/*,application/pdf",
                    onChange: onCinVersoChange
                  }, null, 32),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: _normalizeClass(iconClass(cinVerso.value))
                    }, "VERSO", 2),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(cinVerso.value?.name ?? "Charger le verso"), 1),
                      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "hint" }, "JPG, PNG, PDF", -1))
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (user.cin_verified === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Vérification en cours"))
                : (user.cin_verified === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Identité approuvée"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "error" }, "Document refusé", -1)),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(user.raison_cin_verified), 1),
                      _createElementVNode("button", {
                        class: "retry",
                        onClick: resetCin
                      }, "Réessayer")
                    ], 64))
            ])),
        (!user.ask_cin_verified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("button", {
                disabled: !cinRecto.value || !cinVerso.value || loading.value,
                onClick: sendCin,
                class: _normalizeClass(buttonClass(!cinRecto.value || !cinVerso.value))
              }, _toDisplayString(loading.value ? "Traitement..." : "Soumettre Identité"), 11, _hoisted_17)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
          _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Contrat de Service")
        ], -1)),
        (!user.ask_cntr_verified)
          ? (_openBlock(), _createElementBlock("label", _hoisted_20, [
              _createElementVNode("input", {
                type: "file",
                hidden: "",
                accept: "image/*,application/pdf",
                onChange: onContratChange
              }, null, 32),
              (!contratFile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[5] || (_cache[5] = [
                    _createElementVNode("p", { class: "title" }, "Charger le contrat signé", -1),
                    _createElementVNode("p", { class: "hint" }, "Cliquez ou glissez le fichier", -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, "✓ " + _toDisplayString(contratFile.value.name), 1),
                    _createElementVNode("button", {
                      class: "retry mt-2",
                      onClick: _withModifiers(clearContrat, ["prevent"])
                    }, " Changer ")
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (user.contrat_verified === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Analyse du contrat"))
                : (user.contrat_verified === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Contrat validé"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "error" }, "Contrat rejeté", -1)),
                      _createElementVNode("p", _hoisted_27, _toDisplayString(user.raison_cntr_verified), 1),
                      _createElementVNode("button", {
                        class: "retry btn btn-primary",
                        onClick: resetContrat
                      }, "Renvoyer")
                    ], 64))
            ]))
      ]),
      (!user.ask_cntr_verified)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("button", {
              disabled: !contratFile.value || loading.value,
              onClick: sendContrat,
              class: _normalizeClass(buttonClass(!contratFile.value))
            }, _toDisplayString(loading.value ? "Soumission..." : "Envoyer le Contrat"), 11, _hoisted_29)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})